<div class="modal">
    <div class="header">
        <h1>
            <ng-container *ngIf="!!selectedIdentity?.email">
                {{ selectedIdentity.email }}
            </ng-container>
            <ng-container *ngIf="!!selectedIdentity?.userId">
                {{ 'MODAL_EVENT_LIST_EVENTS_MAIN_TITLE_ANONYMOUS_USER' | translate }}
            </ng-container>
        </h1>
    </div>
    <div class="body">
        <div class="section">
            <ng-container *ngIf="filteredEvents && filteredEvents.length; else noTransferEvents">
                <app-smash-data-table [data]="filteredEvents" [columns]='columnsEnabledEvents' [enableOptions]="false" [paginationEnabled]="true">
                </app-smash-data-table>
            </ng-container>
            <ng-template #noTransferEvents>
                <span>
                    {{ 'MODAL_EVENT_LIST_EVENTS_TABLE_PLACEHOLDER_NO_ACTIVITY' | translate }}
                </span>
            </ng-template>
        </div>
    </div>
</div>